import React from 'react'

import { Container } from 'react-bootstrap'

const Billing = props => {
	
	return (
		<div className="main">
			<Container className="text-center ">
				<h1>Billing</h1>
		
			</Container>
		</div>


		
	)
}

export default Billing;